import { render, staticRenderFns } from "./ItemCardMerchant.vue?vue&type=template&id=35cd31f4&scoped=true&"
import script from "./ItemCardMerchant.vue?vue&type=script&lang=js&"
export * from "./ItemCardMerchant.vue?vue&type=script&lang=js&"
import style0 from "./ItemCardMerchant.vue?vue&type=style&index=0&id=35cd31f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cd31f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAvatar,VBtn,VCard,VHover,VIcon,VListItemAvatar,VTextField})
